import { detectLanguage, loadLanguage } from "./i18n";

// The viewer's language loads before ANY app code runs (the boot spinner in
// public/index.html covers it; English needs no download; a failed download,
// or one still stalled after 3 s, keeps English (i18n LANGUAGE_LOAD_TIMEOUT_MS);
// admin is always English). Only then is the app imported, so
// text set at the top of a module (label tables, constants) is read in the
// right language. webpackMode "eager" keeps it in the same file: no extra
// download, it just runs later.
const isAdmin = window.location.pathname.startsWith("/admin");
// A Spotlight screen link (/s/<code>, on an iPad or a venue TV) starts the
// screen alone, from its own chunk: the talent app never runs there.
const isSpotlight = /^\/s\/[^/]+\/?$/.test(window.location.pathname);

const language = loadLanguage(isAdmin ? "en" : detectLanguage());
if (isSpotlight) language.then(() => import("./pages/spotlight/spotlightBoot"));
else language.then(() => import(/* webpackMode: "eager" */ "./boot"));
